import React from 'react';
import $ from 'jquery';

import '../../../public/css/media/_prohibited-items.scss';

const createReactClass = require('create-react-class');
const ProhibitedItemsDashboard = createReactClass({
  componentWillReceiveProps() {
    $('#SCTitle').text("Prohibited | ShippingCart");
  },
  componentDidMount() {
    window.scrollTo(0, 0);
  },
  handleProhibited(e) {
    e.preventDefault();
    window.FreshWidget.show();
  },
  handleDate(date) {
    if (date) {
      var sliced_date = date.slice(0, 10);
      var split_date = sliced_date.split("-");
      var new_date = split_date[1] + "/" + split_date[2] + "/" + split_date[0].substring(2, 4)

      return new_date;
    }
    else { return null; }
  },
  render() {
    const fName = this.props.login.login ? this.props.login.login.party.first_name : "";
    const lName = this.props.login.login ? this.props.login.login.party.last_name : "";
    const accountNumber = this.props.login.login ? this.props.login.login.party.account_number : "";
    const new_line = escape("\n");
    return (
      <div>
        <div className="main-content prohibited-content">
          <div className="prohibited-wrapper not-eligible">
            <div className="header">
              <h3>You have items not eligible for international shipping</h3>
            </div>
            <table className="prohibited-list" id="prohibited-items">
              <thead>
                <tr>
                  <th>Item/s</th>
                  <th>Courier</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>

                {this.props.parcelInfo.parcel_fetching ? null : !this.props.parcelInfo.parcel_fetching && this.props.parcelInfo.getProhibited ? this.props.parcelInfo.prohibited.data.map((item, i) =>
                  <tr key={i}>
                    <td className="item-info">
                      <p className="name">
                        {item.description}
                      </p>
                      <p className="date">
                        DATE STORED: {this.handleDate(item.updated_at_warehouse)}
                      </p>
                    </td>
                    <td className="courier-info">
                      <p className="courier-name">
                        {item.courier}
                      </p>
                      <p className="item-tracking">
                        Tracking # {item.tracking_number}
                      </p>
                    </td>
                    <td className="contact">
                      <div className="customer-label">
                        <a className="btn btn-orange" href={`mailto:customercare@shippingcart.com?subject=[Prohibited Item] ${fName} ${lName} / ${item.tracking_number}&body=Customer Name: ${fName} ${lName}${new_line}Account Number: ${accountNumber}${new_line}Courier Tracking: ${item.tracking_number}${new_line}Received Date: ${this.handleDate(item.created_at)}${new_line}Prohibited Item Name: ${item.description}`}>Contact Customer Care for return</a>
                      </div>
                    </td>
                  </tr>) : null}
              </tbody>
            </table>
            <div className="note">
              <p>
                Note that as the buyer, you will need to shoulder any fees and taxes incurred by the return of your item/s. We recommend you take action immediately as storage fees will apply after 30 days of receipt.
                         </p>
            </div>
          </div>

        </div>
        {/*Modal for Tracking Shipments*/}
        <div id="modal_tracking" className="modal tracking">
          <div className="modal-dialog">
            <div className="modal-content">
              <header className="modal-header clearfix">
                <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                <div className="left">
                  <h4 className="modal-title">Current Activity:</h4>
                  <p className="activity"></p>
                </div>
                <div className="right">
                  <div className="shipment-status"></div>
                  <p>Tracking #: <span className="modal-tracking-num"></span></p>
                  <span className="hidden csrf">616b9bd66380e926bc97d3c5895f3d5a</span>
                </div>
              </header>

              <div className="shipment-wrap">
              </div>
            </div>
            <div className="loader-overlay">

            </div>
          </div>
        </div>
        <script id="tntLazyInfo" type="text/html">
          <div className="track-and-trace">
            <div className="top-label"><strong>Latest Update:</strong></div>
            <div className="update-date">[[date]]</div>
            <div className="update-details">[[details]]</div>
          </div>
        </script>
        <script id="tntLazyLoader" type="text/html">
          <div className="track-and-trace">
            <div className="top-label"><strong>Latest Update:</strong></div>
            <div className="loader">
              <i className="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        </script>
      </div>
    )
  },
});

export default ProhibitedItemsDashboard;



/** WEBPACK FOOTER **
 ** ./src/components/DashboardFiles/ProhibitedItems.js
 **/